import { STANDARD_SIDEBAR } from '@ublique/components/SideNavPage/constants'

export const defaultPermission = {
  create: true,
  read: true,
  update: true,
  delete: true,
  export: true,
  import_: true
}

export const defaultPages = {
  manager: true,
  dashboard: true,
  scheduled: false,
  purger: false
}

export const initialState = {
  buffer: {},
  originalData: [],
  scheduledData: [],
  purgerData: [],
  notifications: [],
  tableActions: {},
  permissions: {}
}

export const initialScenarioModelConfig = {
  scenario: {
    sidebar: STANDARD_SIDEBAR,
    uploadButton: {},
    additionalColumns: [],
    permissions: {
      ...defaultPermission
    }
  },
  wizard: {
    cloning: false,
    enumScenarioType: {},
    config: {}
  }
}
